import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex gap-2',
    price: '',
    oldPrice: 'text-secondary-hover line-through'
  },
  variants: {},
  defaultVariants: {}
});
